module.exports = __webpack_public_path__ + "img/mobile-signal-out.13cc2dd4.svg";